import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'avanoButtonBarIsActive'
})
export class AvanoButtonBarIsActivePipe implements PipeTransform {
  transform(isButtonDisabled: boolean | Function): boolean {
    let isButtonDisabledValue: boolean;

    if (typeof isButtonDisabled === 'function') {
      isButtonDisabledValue = isButtonDisabled();
    } else {
      isButtonDisabledValue = isButtonDisabled;
    }

    return isButtonDisabledValue;
  }
}
